<div class="login-container" style="flex: 1; display: flex; align-items: center; justify-content: center;">
    <div style="width: 100%; max-width: 500px; padding: 30px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); margin-top: 20%;">
        <h1 style="text-align: center; color: #333;">Login</h1>
        <p style="text-align: center; color: #666; margin-top: 20px;">
            Please click the button below to authenticate.
        </p>
        <app-button [configKey]="'authenticate'" (onClick)="connectToAuthProvider()"></app-button>
    </div>
</div>